const ipo = [
  {
    label: "Securities Code",
    field: "securities_code"
  },
  {
    label: "Securities Abbreviation",
    field: "securities_abbreviation"
  },
  {
    label: "Securities Type Code",
    field: "securities_type_code"
  },
  {
    label: "Securities Type",
    field: "securities_type"
  },
  {
    label: "Total Offering Volume",
    field: "total_offering_volume"
  },
  {
    label: "New Share Offering Volume",
    field: "new_share_offering_volume"
  },
  {
    label: "Par Value per Share",
    field: "par_value_per_share"
  },
  {
    label: "Issue Price",
    field: "issue_price"
  },
  {
    label: "Currency Code ",
    field: "currency_code"
  },
  {
    label: "Currency",
    field: "currency"
  },
  {
    label: "Fully Diluted PE Ratio",
    field: "kfully_diluted_pe_ratio"
  },
  {
    label: "Price Inquiry Range",
    field: "price_inquiry_range"
  },
  {
    label: "Estimated Raised Fund",
    field: "estimated_raised_fund"
  },
  {
    label: "Total Actual Raised Fund",
    field: "total_actual_raised_fund"
  },
  {
    label: "Net Actual Raised Fund",
    field: "net_actual_raised_fund"
  },
  {
    label: "Prospectus Announcement Date",
    field: "prospectus_announcement_date"
  },
  {
    label: "Online Subscription Date",
    field: "online_subscription_date"
  },
  {
    label: "Online Subscription Code",
    field: "online_subscription_code"
  },
  // {
  //   label: "Online Subscription Code",
  //   field: "s"
  // },
  {
    label: "Subscription Code 2",
    field: "subscription_code_2"
  },
  {
    label: "Maximum Online Subscription Volume",
    field: "maximum_online_subscription_volume"
  },
  {
    label: "Minimum Online Subscription Volume",
    field: "minimum_online_subscription_volume"
  },
  {
    label: "Maximum Offline Subscription Volume",
    field: "maximum_offline_subscription_volume"
  },
  {
    label: "Minimum Offline Subscription Volume",
    field: "minimum_offline_subscription_volume"
  },
  {
    label: "Offline Subscription Unit",
    field: "offline_subscription_unit"
  },
  {
    label: "Online Subscription Unit",
    field: "online_subscription_unit"
  },
  {
    label: "Online Lot Winning Rate",
    field: "online_lot_winning_rate"
  },
  {
    label: "Offline Lot Winning Rate",
    field: "offline_lot_winning_rate"
  },
  {
    label: "Online Over-subscription Ratio",
    field: "online_over_subscription_ratio"
  },
  {
    label: "Offline Over-subscription Ratio",
    field: "offline_over_subscription_ratio"
  },
  {
    label: "Online Valid Subscription Shares",
    field: "online_valid_subscription_shares"
  },
  {
    label: "Valid Subscription Accounts",
    field: "valid_subscription_accounts"
  },
  {
    label: "Strategic Investor Placement Volume",
    field: "strategic_investor_placement_account"
  },
  {
    label: "Strategic Investor Placement Account ",
    field: "strategic_investor_placement_volume"
  },
  {
    label: "Listing Announcement Date",
    field: "listing_announcement_date"
  },
  {
    label: "Fund Arrival Date",
    field: "fund_arrival_date"
  },
  {
    label: "Lock-up Period for Shares Placed to Strategic Investors",
    field: "lock_up_period_for_shares_placed_to_strategic_investors"
  },
  {
    label: "Accumulative Price Inquiry",
    field: "accumulative_price_inquiry"
  },
  {
    label: "Spot Promotion Start Date",
    field: "spot_promotion_start_date"
  },
  {
    label: "Spot Promotion End Date",
    field: "spot_promotion_end_date"
  },
  {
    label: "Online Road Show Start Date",
    field: "online_road_show_start_date"
  },
  {
    label: "Price Inquiry Start Date",
    field: "price_inquiry_start_date"
  },
  {
    label: "Price Inquiry  End Date",
    field: "price_inquiry_end_date"
  },
  {
    label: "Issue Price Range Announcement Date",
    field: "issue_price_range_announcement_date"
  },
  {
    label: "Offline Subscription Results and Refund Date",
    field: "offline_subscription_results_and_refund_date"
  },
  {
    label: "Online Subscription Results and Refund Date",
    field: "online_subscription_results_and_refund_date"
  },
  {
    label: "Pricing Announcement Date",
    field: "pricing_announcement_date"
  },
  {
    label: "Lock-up Period for Shares Placed Offline",
    field: "lock_up_period_for_shares_placed_offline"
  },
  {
    label: "Estimated Offering Volume",
    field: "estimated_offering_volume"
  },
  {
    label: "Indicative Proportion of Online Offering",
    field: "indicative_proportion_of_online_offering"
  },
  {
    label: "Indicative Proportion of Offline Placement",
    field: "indicative_proportion_of_offline_placement"
  },
  {
    label: "Offline Subscription Deadline",
    field: "offline_subscription_deadline"
  },
  {
    label: "Prospectus Disclosure Website",
    field: "prospectus_disclosure_website"
  },
  {
    label: "Online Offering Volume",
    field: "online_offering_volume"
  },
  {
    label: "Offline Offering Volume",
    field: "offline_offering_volume"
  },
  {
    label: "Proportion of Shares Issued to Strategic Investors",
    field: "proportion_of_shares_issued_to_strategic_investors"
  },
  {
    label: "Drawing Results Announcement Date",
    field: "drawing_results_announcement_date"
  },
  {
    label: "Lot Winning Rate Announcement Date",
    field: "lot_winning_rate_announcement_date"
  },
  {
    label: "Listing Volume",
    field: "listing_volume"
  },
  {
    label: "Market",
    field: "market"
  },
  {
    label: "Estimated Listing Date",
    field: "estimated_listing_date"
  },
  {
    label: "Input Time",
    field: "input_time"
  },
  {
    label: "Modification Time",
    field: "modification_time"
  },
  {
    label: "Validity",
    field: "validity"
  },
  {
    label: "Offline Placement Start Date",
    field: "offline_placement_start_date"
  }, {
    label: "Offline Placement End Date",
    field: "offline_placement_end_date"
  }, {
    label: "Estimated Ceiling for New Share Offering",
    field: "estimated_ceiling_for_new_share_offering"
  }, {
    label: "Estimated Ceiling for Share Transfer by Existing Shareholders",
    field: "estimated_ceiling_for_share_transfer_by_existing_shareholders"
  }, {
    label: "Estimated Ceiling for Shares Placed to Strategic Investors",
    field: "estimated_ceiling_for_shares_placed_to_strategic_investors"
  }, {
    label: "Shares Transferred by Existing Shareholders",
    field: "shares_transferred_by_existing_shareholders"
  },
  {
    label: "Total Issue Expenses",
    field: "total_issue_expenses"
  },
  {
    label: "Issue Expenses from Share Transfer by Existing Shareholders",
    field: "issue_expenses_from_share_transfer_by_existing_shareholders"
  },
  {
    label: "IPO Progress",
    field: "ipo_progress"
  },
  {
    label: "IPO Progress Code",
    field: "ipo_progress_code"
  },
  {
    label: "Record ID",
    field: "record_id"
  }
];

const publicData = [
  {
    label: "Securities Code",
    field: "securities_code"
  },
  {
    label: "Securities Abbreviation",
    field: "securities_abbreviation"
  },
  {
    label: "Securities Type Code",
    field: "securities_type_code"
  },
  {
    label: "Securities Type",
    field: "securities_type"
  },
  {
    label: "Announcement Date",
    field: "announcement_date"
  },
  {
    label: "Actual Offering Volume",
    field: "actual_offering_volume"
  },
  {
    label: "Public Offering Volume",
    field: "public_offering_volume"
  },
  {
    label: "Par Value per Share",
    field: "par_value_per_share"
  },
  {
    label: "Issue Price",
    field: "issue_price"
  },
  {
    label: "Currency Code ",
    field: "currency_code"
  },
  {
    label: "Currency",
    field: "currency"
  },
  {
    label: "Issuing Method",
    field: "issuing_method"
  },
  {
    label: "Preemptive Placement Price",
    field: "preemptive_placement_price"
  },
  {
    label: "Total Actual Raised Fund",
    field: "total_actual_raised_fund"
  },
  {
    label: "Preemptive Placement Ratio",
    field: "preemptive_placement_ratio"
  },
  {
    label: "加权发行市盈率",
    field: "p"
  },
  {
    label: "Diluted PE Ratio",
    field: "diluted_pe_ratio"
  },
  // {
  //   label: "发行前每股净资产",
  //   field: "r"
  // },
  {
    label: "NAV per Share after Offering",
    field: "nav_per_share_after_offering"
  },
  {
    label: "Estimated Raised Fund",
    field: "estimated_raised_fund"
  },
  {
    label: "Total Actual Raised Fund",
    field: "total_actual_raised_fund"
  },
  {
    label: "Net Actual Raised Fund",
    field: "net_actual_raised_fund"
  },
  {
    label: "Estimated Offering Volume",
    field: "estimated_offering_volume"
  },
  {
    label: "Ex-Date",
    field: "ex_date"
  },
  {
    label: "Record Date",
    field: "record_date"
  },
  // {
  //   label: "发行前总股本",
  //   field: "z"
  // },
  {
    label: "Total Share Capital after Offering",
    field: "total_share_capital_after_offering"
  },
  // {
  //   label: "发行前流通股本",
  //   field: "a2"
  // },
  {
    label: "Floating Share Capital after Offering",
    field: "floating_share_capital_after_offering"
  },
  {
    label: "Online Offering Date",
    field: "online_offering_date"
  },
  {
    label: "Offline Placement  Start Date",
    field: "offline_placement_start_date"
  },
  {
    label: "Offline Placement Deadline",
    field: "offline_placement_deadline"
  },
  {
    label: "Other Offering Date",
    field: "other_offering_date"
  },
  {
    label: "Subscription Abbreviation 1",
    field: "subscription_abbreviation_1"
  },
  {
    label: "Subscription Abbreviation 2",
    field: "subscription_abbreviation_2"
  },
  {
    label: "Online Offering Lot Winning Rate",
    field: "online_offering_lot_winning_rate"
  },
  {
    label: "Offline Offering Lot Winning Rate",
    field: "offline_offering_lot_winning_rate"
  },
  {
    label: "Over-subscription Rate",
    field: "over_subscription_rate"
  },
  {
    label: "Online Offering Volume",
    field: "online_offering_volume"
  },
  {
    label: "Preemptive Placement Volume",
    field: "preemptive_placement_volume"
  },
  {
    label: "Offline Placement Volume",
    field: "offline_placement_volume"
  },
  {
    label: "Online Valid Subscription Shares",
    field: "online_valid_subscription_shares"
  },
  {
    label: "Valid Preemptive Subscription Shares",
    field: "valid_preemptive_subscription_shares"
  },
  {
    label: "Valid Preemptive Subscription Accounts",
    field: "valid_preemptive_subscription_accounts"
  },
  {
    label: "Valid Offline Subscription Accounts",
    field: "valid_offline_subscription_accounts"
  },
  {
    label: "Valid Offline Subscription Shares",
    field: "valid_offline_subscription_shares"
  },
  {
    label: "Shares Subscribed by Strategic Investors",
    field: "shares_subscribed_by_strategic_investors"
  },
  {
    label: "Shares Placed to Strategic Investors",
    field: "shares_placed_to_strategic_investors"
  },
  {
    label: "Strategic Investor Placement Accounts",
    field: "strategic_investor_placement_accounts"
  },
  {
    label: "Listing Announcement Date",
    field: "listing_announcement_date"
  },
  {
    label: "Listing Date",
    field: "listing_date"
  },
  {
    label: "Fund Arrival Date",
    field: "fund_arrival_date"
  },
  {
    label: "Indicative Proportion of Online Offering",
    field: "indicative_proportion_of_online_offering"
  },
  {
    label: "Indicative Proportion of Offline Placement",
    field: "indicative_proportion_of_offline_placement"
  },
  {
    label: "Online  Road Show Start Date",
    field: "online_road_show_start_date"
  },
  {
    label: "Prospectus Disclosure Website",
    field: "prospectus_disclosure_website"
  },
  {
    label: "Preemptive Subscription Date",
    field: "preemptive_subscription_date"
  },
  {
    label: "Percentage of Maximum Preemptive Subscription Volume in Offering Volume",
    field: "percentage_of_maximum_preemptive_subscription_volume_in_offering_volume"
  },
  {
    label: "Minimum Offline Subscription Volume",
    field: "minimum_offline_subscription_volume"
  },
  {
    label: "Proportion of Offline Subscription Deposit",
    field: "proportion_of_offline_subscription_deposit"
  },
  {
    label: "Class A Investors Offline Subscription Lot Winning Rate",
    field: "class_a_investors_offline_subscription_lot_winning_rate"
  },
  {
    label: "Class B Investors Offline Subscription Lot Winning Rate",
    field: "class_b_investors_offline_subscription_lot_winning_rate"
  },
  {
    label: "Class A Investors Offline Subscription Unit",
    field: "class_a_investors_offline_subscription_unit"
  },
  {
    label: "Class B Investors Offline Subscription Unit",
    field: "class_b_investors_offline_subscription_unit"
  },
  {
    label: "Maximum Offline Subscription Volume",
    field: "maximum_offline_subscription_volume"
  }, {
    label: "Class A Investors Minimum Subscription Volume",
    field: "class_a_investors_minimum_subscription_volume"
  }, {
    label: "Class B Investors Minimum Subscription Volume",
    field: "class_b_investors_minimum_subscription_volume"
  }, {
    label: "Class A Investors Subscription Lock-up Period",
    field: "class_a_investors_subscription_lock_up_period"
  }, {
    label: "Offline Refund Date",
    field: "offline_refund_date"
  }, {
    label: "Minimum Online Subscription Volume",
    field: "minimum_online_subscription_volume"
  },
  {
    label: "Online Subscription Unit",
    field: "online_subscription_unit"
  },
  {
    label: "Online Refund Date",
    field: "online_refund_date"
  },
  {
    label: "Online Lot Winning Results Announcement Date",
    field: "online_lot_winning_results_announcement_date"
  },
  {
    label: "Unrestricted  and Unlocked Shares",
    field: "unrestricted_and_unlocked_shares"
  },
  {
    label: "EPS after Offering",
    field: "eps_after_offering"
  },
  {
    label: "Suspension Start Date",
    field: "suspension_start_date"
  },
  {
    label: "Suspension End Date",
    field: "suspension_end_date"
  },
  {
    label: "Offline Lot Winning Results Announcement and Refund Date",
    field: "online_lot_winning_results_announcement_date"
  },
  {
    label: "Record ID",
    field: "record_id"
  },
]


const NonPublicData = [
  {
    label: "Securities Code",
    field: "securities_code"
  },
  {
    label: "Securities Abbreviation",
    field: "securities_abbreviation"
  },
  {
    label: "Securities Type Code",
    field: "securities_type_code"
  },
  {
    label: "Securities Type",
    field: "securities_type"
  },
  {
    label: "Announcement Date",
    field: "announcement_date"
  },
  {
    label: "Listing Date",
    field: "listing_date"
  },
  {
    label: "Actual Offering Volume",
    field: "actual_offering_volume"
  },
  {
    label: "Issue Price",
    field: "issue_price"
  },
  {
    label: "Total Actual Raised Fund",
    field: "total_actual_raised_fund"
  },
  {
    label: "Net Actual Raised Fund",
    field: "net_actual_raised_fund"
  },
  {
    label: "Offering Results Disclosure Website",
    field: "offering_results_disclosure_website"
  },
  {
    label: "Input Time",
    field: "input_time"
  },
  {
    label: "Modification Time",
    field: "modification_time"
  },
  {
    label: "Validity",
    field: "validity"
  },
  {
    label: "Record ID",
    field: "record_id"
  }
];

const rightsIssue = [
  {
    label: "Securities Code",
    field: "securities_code"
  },
  {
    label: "Securities Abbreviation",
    field: "securities_abbreviation"
  },
  {
    label: "Securities Type Code",
    field: "securities_type_code"
  },
  {
    label: "Securities Type",
    field: "securities_type"
  },
  {
    label: "Announcement Date",
    field: "announcement_date"
  },
  {
    label: "Rights Issue Ratio",
    field: "rights_issue_ratio"
  },
  {
    label: "Rights Issue Price",
    field: "rights_issue_price"
  },
  {
    label: "Estimated Rights Issue Volume",
    field: "estimated_rights_issue_volume"
  },
  {
    label: "Estimated Raised Fund",
    field: "estimated_raised_fund"
  },
  {
    label: "Record Date",
    field: "record_date"
  },
  {
    label: "Ex-Date",
    field: "ex-date"
  },
  {
    label: "Payment Start Date",
    field: "payment_start_date"
  },
  {
    label: "Payment End Date",
    field: "payment_end_date"
  },
  {
    label: "Actual Rights Issue Volume",
    field: "actual_rights_issue_volume"
  },
  {
    label: "Total Actual Raised Fund",
    field: "total_actual_raised_fund"
  },
  {
    label: "Net Actual Raised Fund",
    field: "net_actual_raised_fund"
  },
  {
    label: "Fund Arrival Date",
    field: "fund_arrival_date"
  },
  {
    label: "Total Share Capital after Rights Issue",
    field: "total_share_capital_after_rights_issue"
  },
  {
    label: "Floating Share Capital after  Rights Issue",
    field: "floating_share_capital_after_rights_issue"
  },
  {
    label: "Listing Announcement Date",
    field: "listing_announcement_date"
  },
  {
    label: "Listing Date",
    field: "listing_date"
  },
  {
    label: "Rights Issue Warrants Transaction Start Date",
    field: "rights_issue_warrants_transaction_start_date"
  },
  {
    label: "Rights Issue Warrants Transaction End Date",
    field: "rights_issue_warrants_transaction_end_date"
  },
  {
    label: "Subscription Refund Date upon Failure of Rights Issue",
    field: "subscription_refund_date_upon_failure_of_rights_issue"
  },
  {
    label: "Suspension Start Date",
    field: "suspension_start_date"
  },
  // {
  //   label: "Listing Date",
  //   field: "z"
  // },
  {
    label: "Suspension End Date",
    field: "suspension_end_date"
  },
  {
    label: "Issuing Method",
    field: "issuing_method"
  },
  {
    label: "Rights Issue Results Announcement Date",
    field: "rights_issue_results_announcement_date"
  },
  {
    label: "Record ID",
    field: "record_id"
  }
];


const OperatingCashFlow = [
  {
    label: "year",
    field: "a"
  },
  {
    label: "Net Income/Starting Line",
    field: "a"
  },
  {
    label: "Def. Inc. Taxes & Invest. Tax Credit",
    field: "a"
  },
  {
    label: "Other Cash Flow",
    field: "a"
  },
  {
    label: "Funds from Operations before WC Changes & Extra.",
    field: "a"
  },
  {
    label: "Funds from Other Op. Activities",
    field: "a"
  },
  {
    label: "Net Cash from Operating Activities",
    field: "a"
  }
];

const operatingCashFlow = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Net Income/Starting Line",
    field: "net_income_starting_line"
  },
  {
    label: "Def. Inc. Taxes & Invest. Tax Credit",
    field: "def_inc_taxes_invest_tax_credit"
  },
  {
    label: "Other Cash Flow",
    field: "other_cash_flow"
  },
  {
    label: "Funds from Operations before WC Changes & Extra.",
    field: "funds_from_operations_before_wc_changes_extra"
  },
  {
    label: "Funds from Other Op. Activities",
    field: "funds_from_other_op_activities"
  },
  {
    label: "Net Cash from Operating Activities",
    field: "net_cash_from_operating_activities"
  }
];

const investingCashFlow = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Additions to Fixed Assets",
    field: "additions_to_fixed_assets"
  },
  {
    label: "Increase/Decrease Other Long Term Assets",
    field: "increase_decrease_other_long_term_assets"
  },
  {
    label: "Increase/Decrease in Investments",
    field: "increase_decrease_in_investments"
  },
  {
    label: "Net Cash used by Investing Activities",
    field: "net_cash_used_by_investing_activities"
  }
];


const financingCashFlow = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Inc/Dec in ST Borrowing",
    field: "inc_dec_in_st_borrowing"
  },
  {
    label: "Inc/Dec in Long Term Borrowing",
    field: "inc_dec_in_long_term_borrowing"
  },
  {
    label: "Net Proceeds from Sale/Issue Com. & Pref. Stock",
    field: "net_proceeds_from_sale_issue_com_pref_stock"
  },
  {
    label: "Shareholders' Equity Reserve",
    field: "shareholders_equity_reserve"
  },
  {
    label: "Common Dividends (Cash)",
    field: "common_dividends_cash"
  },
  {
    label: "Preferred Dividends (Cash)",
    field: "preferred_dividends_cash"
  },
  {
    label: "Cash Dividends Paid - Total",
    field: "cash_dividends_paid_total"
  },
  {
    label: "Other Source/Use - Financing Activities",
    field: "other_source_use_financing_activities"
  },
  {
    label: "Net Cash provided by/used in Financing Activities",
    field: "net_cash_provided_by_used_in_financing_activities"
  }
];

const balance = [
  {
    label: "year",
    field: "year"
  },
  {
    label: "Effect of Exchange Rate on Cash",
    field: "effect_of_exchange_rate_on_cash"
  },
  {
    label: "Inc/Dec in Cash & ST Investments",
    field: "inc_dec_in_cash_st_investments"
  },
  {
    label: "Cash & Equivalents at Beginning of Year",
    field: "cash_equivalents_at_beginning_of_year"
  },
  {
    label: "Cash & Equivalents at End of Year",
    field: "cash_equivalents_at_end_of_year"
  }
];


// 美国数据
const AoperatingCashFlow = [
  {
    label: "year",
    field: "a"
  },
  {
    label: "Net Income",
    field: "a"
  },
  {
    label: "Depreciation",
    field: "a"
  },
  {
    label: "Depreciation/Depletion",
    field: "a"
  },
  {
    label: "Amortization",
    field: "a"
  },
  {
    label: "Deferred Taxes",
    field: "a"
  },
  {
    label: "Non-Cash Items",
    field: "a"
  },
  {
    label: "Cash Receipts",
    field: "a"
  },
  {
    label: "Cash Payments",
    field: "a"
  },
  {
    label: "Changes in Working Capital",
    field: "a"
  },
  {
    label: "Total Cash from Operating Activities",
    field: "a"
  }
];

const AinvestingCashFlow = [
  {
    label: "year",
    field: "a"
  },
  {
    label: "Purchase of Fixed Assets",
    field: "a"
  },
  {
    label: "Purchase/Acquisition of Intangibles",
    field: "a"
  },
  {
    label: "Software Development Costs",
    field: "a"
  },
  {
    label: "Capital Expenditures",
    field: "a"
  },
  {
    label: "Other Investing Cash Flow Items, Total",
    field: "a"
  },
  {
    label: "Total Cash from Investing Activities",
    field: "a"
  }
];


const AfinancingCashFlow = [
  {
    label: "year",
    field: "a"
  },
  {
    label: "Other Financing Cash Flow",
    field: "a"
  },
  {
    label: "Financing Cash Flow Items",
    field: "a"
  },
  {
    label: "Total Cash Dividends Paid",
    field: "a"
  },
  {
    label: "Issuance (Retirement) of Stock, Net",
    field: "a"
  },
  {
    label: "Issuance (Retirement) of Debt, Net",
    field: "a"
  },
  {
    label: "Total Cash from Financing Activities",
    field: "a"
  }
];

const Abalance = [
  {
    label: "year",
    field: "a"
  },
  {
    label: "Foreign Exchange Effects",
    field: "a"
  },
  {
    label: "Net Change in Cash",
    field: "a"
  },
  {
    label: "Net Cash - Beginning Balance",
    field: "a"
  },
  {
    label: "Net Cash - Ending Balance",
    field: "a"
  }
];

const Asupplementals = [
  {
    label: "year",
    field: "a"
  },
  {
    label: "Depreciation, Supplemental",
    field: "a"
  },
  {
    label: "Cash Interest Paid, Supplemental",
    field: "a"
  },
  {
    label: "Cash Taxes Paid, Supplemental",
    field: "a"
  }
];


export default {
  ipo,
  publicData,
  NonPublicData,
  rightsIssue,
  operatingCashFlow,
  investingCashFlow,
  financingCashFlow,
  balance,
  AoperatingCashFlow,
  AinvestingCashFlow,
  AfinancingCashFlow,
  Abalance,
  Asupplementals
}